import styled from 'styled-components';
import ContentEditable from 'react-contenteditable';

import Button from 'web-components/Button';

import {
  Flex,
} from 'web-styled';

export const File = styled(Flex).attrs({
  spacing: 5,
  align: 'center',
  justify: 'space-between',
})`
  width: 100%;

  &:last-of-type {
    padding-bottom: 25px;
    border-bottom: 1px solid #ededed;
  }
`;

export const Progress = styled.div`
  height: 5px;
  width: ${props => props.progress}%;
  border-radius: 5px;
  overflow: hidden;
  background-color: #39ca74;
  transition: all 0.2s linear;
`;

export const Name = styled(ContentEditable)`
  color: #808080;
  font-size: 14px;
  padding: 2px 5px;
  margin-left: -5px;
  border-radius: 3px;
  border: 1px solid transparent;
  outline: none;

  &:focus {
    border-color: ${props => props.theme.colors.primary};
  }
`;

export const Action = styled(Button).attrs({
  spacing: 'none',
  iconSize: 13,
  appearance: 'empty',
})`
  color: rgba(0, 0, 0, 0.15);

  &:hover {
    color: ${props => props.theme.colors.primary};
  }
`;
